import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles.css';
import './responsive.css';

// Componentes
//import Navbar from './components/Navbar';
//import Footer from './components/Footer';
//import Whatsapp from './components/Whatsapp';
import ScrollToTop from './functions/ScrollToTop';

//Landing Vasos Promocionales
//import FooterLanding from './landing/components/FooterLanding';
//import NavbarLanding from './landing/components/NavbarLanding';
import Landings from './landing/pages/Landing';
import LandingLayout from './landing/LandingLayout';

//Landing Etiquetas
import LandingEtiquetas from './landingEtiquetas/pages/LandingEtiquetas';
import LandingEtiquetasLayout from './landingEtiquetas/LandingEtiquetasLayout';

// Páginas
import MainLayout from './MainLayout';
import NoFooterLayout from './NoFooterLayout';
import Inicio from './pages/Inicio';
import NuestraEsencia from './pages/NuestraEsencia';
import SolucionesIndustria from './pages/SolucionesIndustria';
import Productos from './pages/Productos';
import Maquinaria from './pages/Maquinaria';
import Certificaciones from './pages/Certificaciones';
import HistoriasExito from './pages/HistoriasExito';
import Contacto from './pages/Contacto';
import Test from './pages/Test';
//import ScrollToAnchor from './functions/ScrollToAnchor';

function App() {
  return (
    <>
    <BrowserRouter>
      <ScrollToTop />
      {/*<ScrollToAnchor />*/}
      <Suspense fallback={<div>Cargando...</div>}>
        <Routes>
          {/* LANDING en /vasospromocionales */}
          <Route path="/vasospromocionales" element={<LandingLayout />}>
            <Route index element={<Landings />} />
            {/* más secciones de la landing si quieres */}
          </Route>

          {/* LANDING en /landingetiquetas */}
          <Route path="/landingetiquetas" element={<LandingEtiquetasLayout />}>
            <Route index element={<LandingEtiquetas />} />
          </Route>

          {/* SITIO PRINCIPAL en /#/ */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Inicio />} />
            <Route path="nuestra-esencia" element={<NuestraEsencia />} />
            <Route path="soluciones-industria" element={<SolucionesIndustria />} />
            <Route path="productos" element={<Productos />} />
            <Route path="maquinaria" element={<Maquinaria />} />
            <Route path="certificaciones" element={<Certificaciones />} />
            <Route path="historias-exito" element={<HistoriasExito />} />
            <Route path="contacto" element={<Contacto />} />
          </Route>
          {/*Test */}
          <Route path="/" element={<NoFooterLayout />}>
            <Route path="test" element={<Test />} />
          </Route>
        </Routes>
      </Suspense>


    </BrowserRouter>
     {/*<div className="App d-flex flex-column min-vh-100">
        <Navbar />
        <ScrollToTop/>
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/nuestra-esencia" element={<NuestraEsencia />} />
            <Route path="/soluciones-industria" element={<SolucionesIndustria />} />
            <Route path="/maquinaria" element={<Maquinaria />} />
            <Route path="/certificaciones" element={<Certificaciones />} />
            <Route path="/historias-exito" element={<HistoriasExito />} />
            <Route path="/contacto" element={<Contacto />} />
            
          </Routes>
        </main>
        <Footer />
        <Whatsapp/>
      </div>*/}
    {/*<HashRouter>
      <div>
        <div className="App d-flex flex-column min-vh-100">
          <Navbar />
          <ScrollToTop/>
          <main className="flex-grow-1">
            <Routes>
              <Route path="/landings" element={<Landings />} />
            </Routes>
          </main>
          <FooterLanding/>
          <Whatsapp/>
        </div>
      </div>
    </HashRouter>*/}
    </>
  );
}

export default App;
